// Analytics/TabContent.jsx
import React from 'react';
import { Typography } from '@mui/material';
import OutpatientsTab from './tabs/OutpatientsTab';
import { IDepartment } from '../../../constants/types';
import { AnalyticsViewMode } from './types';
import InpatientsTab from './tabs/InpatientsTab';
import LabTab from './tabs/LabTab';
import RadiologyTab from './tabs/RadiologyTab';
import FinancesTab from './tabs/FinancesTab';
import SurgeryTab from './tabs/SurgeryTab';
import { EMPTY_SURGERY_ANALYTICS_FILTERS, SurgeryAnalyticsFiltersQuery } from './types';

interface TabContentProps {
  activeTabId: string;
  loading: boolean;
  startDate: string;
  endDate: string;
  investigation: {
    permissions: string[];
    [key: string]: any;
  };
  departmentSelected: string;
  departments: IDepartment[];
  // SHER-562. Outpatients and Surgery tabs have view modes; the other tabs ignore it.
  mode: AnalyticsViewMode;
  surgeryFilters: SurgeryAnalyticsFiltersQuery;
}

const TabContent: React.FC<TabContentProps> = ({
  activeTabId,
  loading,
  startDate,
  endDate,
  investigation,
  departmentSelected,
  departments,
  mode,
  surgeryFilters,
}) => {
  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  const commonProps = {
    investigation,
    departmentSelected,
    startDate,
    endDate,
    departments,
    tabNumber: 0,
  };

  switch (activeTabId) {
    case 'outpatients':
      return <OutpatientsTab {...commonProps} mode={mode} />;
    case 'inpatients':
      return <InpatientsTab {...commonProps} />;
    case 'surgery':
      return (
        <SurgeryTab
          {...commonProps}
          mode={mode}
          surgeryFilters={surgeryFilters ?? EMPTY_SURGERY_ANALYTICS_FILTERS}
        />
      );
    case 'laboratory':
      return <LabTab {...commonProps} />;
    case 'radiology':
      return <RadiologyTab {...commonProps} />;
    case 'finances':
      return <FinancesTab {...commonProps} />;
    default:
      return <Typography>No data available for this tab.</Typography>;
  }
};

export default TabContent;
